import { render, staticRenderFns } from "./EventsListing.vue?vue&type=template&id=28bc7930&"
import script from "./EventsListing.vue?vue&type=script&lang=js&"
export * from "./EventsListing.vue?vue&type=script&lang=js&"
import style0 from "./EventsListing.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports